// Base API URL - different for development and production
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://soldikeeper-backend-production.up.railway.app/api';

// API endpoints
const ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    REGISTER: `${API_BASE_URL}/auth/register`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    ME: `${API_BASE_URL}/auth/me`,
    HEALTH: `${API_BASE_URL}/auth/health`,
  },
  BUDGETS: {
    BASE: `${API_BASE_URL}/budgets`,
    BY_ID: (id) => `${API_BASE_URL}/budgets/${id}`,
  },
  TRANSACTIONS: {
    BASE: `${API_BASE_URL}/transactions`,
    BY_ID: (id) => `${API_BASE_URL}/transactions/${id}`,
  },
  USER_PREFERENCES: {
    BASE: `${API_BASE_URL}/userPreferences`,
  }
};

// Request headers
const HEADERS = {
  DEFAULT: {
    'Content-Type': 'application/json',
  },
  WITH_AUTH: (token) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }),
};

// Request timeout
const TIMEOUT = 30000; // 30 seconds

export default {
  API_BASE_URL,
  ENDPOINTS,
  HEADERS,
  TIMEOUT
};